var _circle, _rect, _g, _rect2, _g2, _rect3, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBigTemplates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#DADFF7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.7,
    y: 9.5,
    width: 15.2,
    height: 15.2,
    rx: 2.375,
    fill: "#B5BEEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.825 16.863a.713.713 0 0 1 .713-.713h4.274a.713.713 0 0 1 .713.713v4.274a.712.712 0 0 1-.712.713h-4.275a.712.712 0 0 1-.713-.713v-4.274z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 8.075,
    y: 12.825,
    width: 10.925,
    height: 1.425,
    rx: 0.713,
    fill: "#465DD8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 8.075,
    y: 15.2,
    width: 10.925,
    height: 1.425,
    rx: 0.713,
    fill: "#465DD8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 8.075,
    y: 17.575,
    width: 10.925,
    height: 1.425,
    rx: 0.713,
    fill: "#465DD8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 8.075,
    y: 19.95,
    width: 10.925,
    height: 1.425,
    rx: 0.713,
    fill: "#465DD8"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.1,
    y: 11.4,
    width: 15.2,
    height: 15.2,
    rx: 2.375,
    fill: "#7E8EE4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    fill: "#465DD8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.65 20.425a.475.475 0 0 1 .475-.475h2.85a.475.475 0 0 1 .475.475v2.85a.475.475 0 0 1-.475.475h-2.85a.475.475 0 0 1-.475-.475v-2.85zM25.65 14.725a.475.475 0 0 1 .475-.475h2.85a.475.475 0 0 1 .475.475v2.85a.475.475 0 0 1-.475.475h-2.85a.475.475 0 0 1-.475-.475v-2.85z"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.4,
    y: 13.3,
    width: 15.2,
    height: 15.2,
    rx: 2.375,
    fill: "#465DD8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 16.863a.67.67 0 0 1 .239-.504.877.877 0 0 1 .575-.209h9.772c.216 0 .423.075.576.209a.67.67 0 0 1 .238.503v1.426a.67.67 0 0 1-.238.503.877.877 0 0 1-.576.209h-9.772a.877.877 0 0 1-.575-.209.67.67 0 0 1-.239-.503v-1.425z",
    fill: "#7E8EE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.05 20.663c0-.19.088-.37.244-.504a.906.906 0 0 1 .587-.209h4.988c.22 0 .432.075.588.209a.665.665 0 0 1 .243.504v4.275c0 .189-.087.37-.243.503a.907.907 0 0 1-.588.21H18.88a.907.907 0 0 1-.587-.21.665.665 0 0 1-.244-.503v-4.275z",
    fill: "#F0F3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 19.95a1.13 1.13 0 0 0-.672.209c-.178.133-.278.315-.278.504v4.275c0 .189.1.37.278.503.179.134.42.21.672.21h1.9c.252 0 .494-.076.672-.21.178-.133.278-.314.278-.503v-4.275c0-.19-.1-.37-.278-.504a1.13 1.13 0 0 0-.672-.209h-1.9z",
    fill: "#B5BEEF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBigTemplates);
export default __webpack_public_path__ + "static/media/Icon_Big_Templates.b38160e2.svg";
export { ForwardRef as ReactComponent };